import { render, staticRenderFns } from "./SuperAdminSelect.vue?vue&type=template&id=0215e477&"
import script from "./SuperAdminSelect.vue?vue&type=script&lang=js&"
export * from "./SuperAdminSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports